// extracted by mini-css-extract-plugin
export default {"panel":"Panel_panel__dPwCf","info":"Panel_info__t-x4y","note":"Panel_note__dx0UK","close":"Panel_close__04ALt","btns":"Panel_btns__35P3C","button":"Panel_button__DCKNn"};